/**
 * Stream Parser Utility
 *
 * Parses Server-Sent Events (SSE) from streaming API responses.
 * Reusable across any streaming endpoint that uses JSON SSE format.
 */

export interface StreamEvent {
  content?: string;
  [key: string]: any;
}

/**
 * Parse a single SSE event line
 * Handles JSON parsing with graceful error handling
 */
export function parseStreamEvent(data: string): StreamEvent | null {
  if (!data || data === "[DONE]") {
    return null;
  }

  try {
    return JSON.parse(data) as StreamEvent;
  } catch (e) {
    // Ignore parsing errors for incomplete chunks
    return null;
  }
}

/**
 * Parse multiple SSE lines from a chunk
 */
export function parseStreamChunk(chunk: string): StreamEvent[] {
  const lines = chunk.split("\n");
  const events: StreamEvent[] = [];

  for (const line of lines) {
    if (line.startsWith("data: ")) {
      const data = line.slice(6);
      const event = parseStreamEvent(data);
      if (event) {
        events.push(event);
      }
    }
  }

  return events;
}

/**
 * Check if a line is a stream terminator
 */
export function isStreamDone(line: string): boolean {
  return line.slice(6) === "[DONE]";
}
